<header>
    <div class="header1">
        <div class="row col-sm-12 col-md-12">
            <div class="col-sm-1 col-md-1"></div>
            <div class="col-sm-3 col-md-3">
                <span class="hide1" style="color:
                    #00d3f3;padding-right: 20px;font-size: 12px;"><i class="fa
                        fa-phone"
                        style="color: white;padding-right: 5px;"></i> <b>+91
                        8328579397</b>
                </span>
            </div>
            <div class="col-sm-8 col-md-8">
                <div style="float: right;" class="hide2">
                    <span style="color:
                        #ccd0d9;padding-right: 10px;font-size: 12px;"><b>yourDesiCart</b></span>
                    <span style="margin: 0px 5px 0px 0px">
                        <a itemprop="url" class=""
                            href="https://www.facebook.com/yourDesiCart"
                            target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal">
                                    <i class="qodef-icon-font-awesome fa
                                        fa-facebook qodef-icon-element"
                                        style="color:white;font-size:14px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class="" href="https://twitter.com/"
                            target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa
                                        fa-twitter qodef-icon-element"
                                        style="color:white;font-size:14px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class=""
                            href="https://in.pinterest.com/yourDesiCart/"
                            target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa
                                        fa-pinterest qodef-icon-element"
                                        style="color:white;font-size:14px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class=""
                            href="https://www.instagram.com/yourDesiCart"
                            target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal">
                                    <i
                                        class="qodef-icon-font-awesome fa
                                        fa-instagram qodef-icon-element"
                                        style="color:white;font-size:14px"
                                        onMouseOver="this.style.color='rgb(0,211,243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span class="example">

                        <input type="text" placeholder="Search" name="search">
                        <button type="submit"><a
                                href="https://yourdesicart.com/" target="_blank"
                                style="color: white;"><i class="fa fa-search"></i></a></button>
                        <!-- <input type="text" size="20">
                    <div id="search-3" class="widget widget_search qodef-top-bar-widget">
                        <form method="get" id="searchform" action="https://yourdesicart.com/">
                        <div><label class="screen-reader-text" for="s">Search for:</label>
                            <input type="text" value="" placeholder="Search" name="s" id="s">
                            <input type="submit" id="searchsubmit" value="">
                        </div>
                    </form></div> -->
                    </span>
                </div>


            </div>
        </div>




    </div>
</header>
<nav class="navbar navbar-expand-lg sticky-top navbar-light bg-white">
    <a class="navbar-brand" (click)="onHome();$event.stoppropagation">
       
    </a>
    <button class="navbar-toggler btn-white collapsed" type="button"
        data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <i class="fa fa-bars text-black"></i>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-auto">
            <li class="nav-item active" (click)="onHome();$event.stoppropagation">
          <a class="nav-link text-black ml-3" routerLink="homepage" routerLinkActive="active_yellow">Home</a>
        </li>
        <li class="nav-item active" (click)="onHow();$event.stoppropagation">
            <a class="nav-link text-black ml-3" routerLink="how" routerLinkActive="active_yellow">How</a>
        </li>
        <li class="nav-item active" (click)="onPricing();$event.stoppropagation">
            <a class="nav-link text-black ml-3" routerLink="pricing" routerLinkActive="active_yellow">Pricing & Services</a>
        </li>
            <li class="nav-item active"
                (click)="onShipping();$event.stoppropagation">
                <a class="nav-link text-black ml-3" routerLink="shipping"
                    routerLinkActive="active_yellow">Shipping calculator</a>
            </li>
            <li class="nav-item active" (click)="onShop();$event.stoppropagation">
            <a class="nav-link text-black ml-3" routerLink="shop" routerLinkActive="active_yellow">Shop</a>
        </li>
        </ul>
        <form class="form-inline my-2 my-lg-0">
            <div class="nav-item dropdown user_dropDown" *ngIf="Auth">
                <p class="nav-link dropdown-toggle text-black"
                    [ngClass]="useremail.length <= 7 ? 'dropdown_content' :
                    'noMargin'" id="navbarDropdown" role="button"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    {{useremail}}
                </p>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <div (click)="onAccount();$event.stoppropagation">
                        <a class="dropdown-item" routerLink="myaccount"
                            routerLinkActive="active_yellow"> <i class="fa
                                fa-user"></i> Account</a>
                    </div>

                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" (click)="logout()"
                        style="cursor:
                        pointer;"> <i class="fa fa-power-off"></i> Logout</a>
                </div>
            </div>
            <button type="button" class="btn text-black login_btn" *ngIf="!Auth"><a class="text-black bbb" href="https://yourdesicart.com/order-now/">Login</a></button>
            <!-- <button type="button" class="btn text-black login_btn" (click)="onSign()" *ngIf="!Auth">Login</button> -->
        </form>
    </div>
</nav>




<!-- <header>
    <div class="container-fluid">
        <div class="branding adjust-left">
            <div class="row hide-in-mob">
                <div class="col-sm-2">
                    <div class="logo">
                        <a [routerLink]="['home']" (click)="signup()"> <img src="assets\Images\Group 23.png" width="69"
                                height="69"></a>
                    </div>
                </div>
                <div class="col-sm-2"></div>
                <div class="col-sm-8">
                    <div class="topnav" id="myTopnav">
                        <a routerLinkActive="active" class="home-link" (click)="onHome()">Home</a>
                        <a routerLinkActive="active" class="how-link" (click)="onHow()">How</a>
                        <a routerLinkActive="active" class="pricing-link" (click)="onPricing()">Pricing &
                            Services</a>
                        
                        <a routerLinkActive="active" class="shop-link" (click)="onShop()">Shop</a>
                        <a class="signup-link" routerLinkActive="active" *ngIf="!Auth"
                                data-backdrop="static" data-keyboard="false" id="new-signup" (click)="onSign()">Login
                            </a>
                      
                        <div class="center" *ngIf="!Auth">
                            <button mat-raised-button class="btn button-style float-right"> 
                                <a class="signup-link"
                                data-backdrop="static" data-keyboard="false" class="float-right" (click)="onSign()">Login
                            </a>
                        </button>
                            
                        </div>

                        <span (click)="myPopupbox()" class="user__details">
                                <a *ngIf="Auth" [routerLink]="[]" data-backdrop="static" data-keyboard="false" id="left"
                                    >{{useremail}} <i class="fa fa-angle-down"
                                    ></i> 
                                   
                                    <span>
                                            <a *ngIf="Auth" [routerLink]="[]">
                                                <span>
                                                    <div class="popup">
                                                       
                                                        <span class="popuptext" id="myPopup">
                                                            <a [routerLink]="['myaccount']" (click)="account()"><i
                                                                    class="fa fa-user active-link"
                                                                    style="margin-right: 10px;margin-left: 0;">&nbsp;Account</i></a>
                                                            <a [routerLink]="[]" (click)="logout()"><i class="fa fa-power-off"
                                                                    style="margin-right: 10px;margin-left: 0;">&nbsp;Logout</i></a>
                                                        </span>
                                                    </div>
                                                </span>
                                            </a>
                                        </span>
                                </a>
                            </span>
                     

                        <a href="javascript:void(0);" class="icon" (click)="myFunction()">
                            <i class="fa fa-bars"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header> -->
<!-- <header>
    <div class="container-fluid">
        <div class="branding adjust-left">
            <div class="row hide-in-mob">
                <div class="col-sm-2">
                    <div class="logo">
                        <a [routerLink]="['home']" (click)="signup()"> <img src="assets\Images\Group 23.png" width="69"
                                height="69"></a>
                    </div>
                </div>
                <div class="col-sm-2"></div>
                <div class="col-sm-8">
                    <div class="topnav" id="myTopnav">
                        <a routerLinkActive="active" class="home-link" (click)="onHome()">Home</a>
                        <a routerLinkActive="active" class="how-link" (click)="onHow()">How</a>
                        <a routerLinkActive="active" class="pricing-link" (click)="onPricing()">Pricing &
                            Services</a>
                        <a [routerLink]="['shipping']" routerLinkActive="active">Shipping Calculator</a>
                        <a [routerLink]="['contact']"  routerLinkActive="active">ContactUs</a>
                        <a  href="#contact" routerLinkActive="active">Login</a>
                        <a [routerLink]="['login']" routerLinkActive="active">Login</a>
                        <a routerLinkActive="active" class="shop-link" (click)="onShop()">Shop</a>
                        <a class="signup-link" routerLinkActive="active" *ngIf="!Auth"
                                data-backdrop="static" data-keyboard="false" id="new-signup" (click)="onSign()">Login
                            </a>
                        <a *ngIf="!useremail" [routerLink]="['login']" class="signup-link" routerLinkActive="active"  data-backdrop="static"
                            data-keyboard="false" class="float-right">SignUp/Login
                        </a>
                        <div class="center" *ngIf="!Auth">
                            <button mat-raised-button class="btn button-style float-right"> 
                                <a class="signup-link"
                                data-backdrop="static" data-keyboard="false" class="float-right" (click)="onSign()">Login
                            </a>
                        </button>
                            <button mat-raised-button color="dark" class="btn button-style float-none" type="submit"
                                style="margin-top: 50px;">Login</button>
                        </div>

                        <span (click)="myPopupbox()" class="user__details">
                                <a *ngIf="Auth" [routerLink]="[]" data-backdrop="static" data-keyboard="false" id="left"
                                    >{{useremail}} <i class="fa fa-angle-down"
                                    ></i> 
                                    class="float-right"
                                    <span>
                                            <a *ngIf="Auth" [routerLink]="[]">
                                                <span>
                                                    <div class="popup">
                                                        <a [routerLink]="[]"><i class="fa fa-angle-down user_info_icon"
                                                                ></i>
                                                               
                                                        </a>
                                                        <span class="popuptext" id="myPopup">
                                                            <a [routerLink]="['myaccount']" (click)="account()"><i
                                                                    class="fa fa-user active-link"
                                                                    style="margin-right: 10px;margin-left: 0;">&nbsp;Account</i></a>
                                                            <a [routerLink]="[]" (click)="logout()"><i class="fa fa-power-off"
                                                                    style="margin-right: 10px;margin-left: 0;">&nbsp;Logout</i></a>
                                                        </span>
                                                    </div>
                                                </span>
                                            </a>
                                        </span>
                                </a>
                            </span>
                     

                        <a href="javascript:void(0);" class="icon" (click)="myFunction()">
                            <i class="fa fa-bars"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header> -->
